import React, { ReactElement } from 'react'
import { box } from 'styled-system/patterns'
import { NavChooseRecipesCTA } from '@mindfulchefuk/features/Navigation/components/Header/shared/NavChooseRecipesCTA'
import { NavSignInCTA } from '@mindfulchefuk/features/Navigation/components/Header/shared/NavSignInCTA'

export const SignedOutNavMobileCTAs = (): ReactElement => {
  return (
    <>
      <div
        className={box({
          mt: 4,
        })}
      >
        <NavChooseRecipesCTA fullWidth />
      </div>
      <div
        className={box({
          mt: 4,
        })}
      >
        <NavSignInCTA fullWidth />
      </div>
    </>
  )
}
